import { useMsal } from "@azure/msal-react";
import React, { createContext, PropsWithChildren, useContext } from "react"
import { authConfig } from "../model/auth";
import { BrowserAuthError } from "@azure/msal-browser";

type AuthHelperType = {
  getAccessToken: (request?: { scopes: string[] }) => Promise<string | undefined>,
  getUserTenant: () => string | undefined
}

const AuthHelperContext = createContext<AuthHelperType | undefined>(undefined);

export const useAuthHelper = (): AuthHelperType => {
  const context = useContext(AuthHelperContext);
  if (!context) {
    throw new Error('useAuthHelper cannot be used outside of AuthHelperProvider');
  }

  return context;
}

export const AuthHelperProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { instance } = useMsal();

  const context: AuthHelperType = {
    getAccessToken: async (request) => {
      try {
        const token = (await instance.acquireTokenSilent({
          ...(request ? request : authConfig),
          account: instance.getActiveAccount() ?? undefined
        })).accessToken;

        return token;
      } catch (er) {
        console.warn(er);
        
        try {
          const token = (await instance.acquireTokenPopup({
            ...(request ? request : authConfig),
            prompt: 'consent'
          })).accessToken;
          return token;
        }
        catch (err) {
          console.warn(err);
          if (err instanceof BrowserAuthError && err.errorCode === 'popup_window_error') {
            alert('Please enable popups to be be able to authorize');
          }

          return undefined;
        }
      }
    },
    getUserTenant: () => {
      return instance.getActiveAccount()?.tenantId ?? undefined
    }
  }
  return (
    <AuthHelperContext.Provider value={context}>
      {children}
    </AuthHelperContext.Provider>
  );
}